import React from 'react';

const FinancialPosition = ({ summary, scope }) => {
    const { debitTotal, creditTotal, netWorth } = summary;

    return (
        <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">Financial Position ({scope})</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-green-100 p-4 rounded-lg">
                    <h3 className="text-sm font-medium text-green-800">Total in Debit Accounts</h3>
                    <p className="text-2xl font-semibold text-green-900">${debitTotal.toFixed(2)}</p>
                </div>
                <div className="bg-red-100 p-4 rounded-lg">
                    <h3 className="text-sm font-medium text-red-800">Total Owed on Credit</h3>
                    <p className="text-2xl font-semibold text-red-900">${creditTotal.toFixed(2)}</p>
                </div>
                <div className="bg-blue-100 p-4 rounded-lg">
                    <h3 className="text-sm font-medium text-blue-800">Net Worth</h3>
                    <p className="text-2xl font-semibold text-blue-900">${netWorth.toFixed(2)}</p>
                </div>
            </div>
        </div>
    );
};

export default FinancialPosition;
